import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { App } from '@capacitor/app';
import { BaseFormComponent } from '@core/abstract-classes/base-form.component';
import { PlatformService } from '@core/services/platform.service';
import { UpdateAppService } from '@core/services/update-app.service';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { from } from 'rxjs';

@Component({
    selector: 'ncodp-modal-update-app',
    templateUrl: 'modal-update-app.component.html',
    styleUrls: ['modal-update-app.component.scss'],
    imports: [IonicModule, TranslateModule, AsyncPipe],
    providers: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalUpdateAppComponent extends BaseFormComponent {
    public appInfo$ = from(App.getInfo());
    public isIosPlatform$ = this.platformService.isIosPlatform$;
    constructor(
        private updateAppService: UpdateAppService,
        private platformService: PlatformService,
    ) {
        super();
    }

    public async openAppStore(): Promise<void> {
        await this.updateAppService.openAppStore();
    }
    public cancel() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }
}
